import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../Assets/Logo.svg";
import "./Navbar.css";
export default function Navbar() {
  const navigate = useNavigate();

  return (
    <div className="navMain">
      <div className="navbar-wrapper">
        <button
          style={{
            padding: "0.5em 1em",
            borderRadius: "25px",
          }}
          onClick={() => {
            navigate("/");
          }}
        >
          <img src={logo} alt="logo" className="logo" />
        </button>
        <button
          style={{
            padding: "0.5em 1em",
            backgroundColor: "#0FBFE6",
            borderRadius: "25px",
            color: "#fff",
          }}
          onClick={() => {
            navigate("SchedulePickUp");
          }}
        >
          Schedule Pick up
        </button>
      </div>
    </div>
  );
}
